import { render, staticRenderFns } from "./ShopRecord.vue?vue&type=template&id=1f5b72e0&"
import script from "./ShopRecord.vue?vue&type=script&lang=js&"
export * from "./ShopRecord.vue?vue&type=script&lang=js&"
import style0 from "./ShopRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports